// extracted by css-extract-rspack-plugin
export default {"narrowingForm":"oRd4w","learningMaterialTags":"_0NzEg"};